/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-rescuebreaths',['require','jquery','screens/scenario-mapper/scenario','activities/activity-checkbreathing','activities/activity-timer'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  //var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  var Scenario = require('screens/scenario-mapper/scenario');
  //var ScenarioActivity = require('activities/scenario-activity');
  var ActivityCheckBreathing = require('activities/activity-checkbreathing');
  var ActivityTimer = require('activities/activity-timer');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityRescueBreaths = ActivityCheckBreathing.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    doneBtn: null,
    minPressCount: 1,
    correctPressCount: 0,
    totalBreathsCount: 0,
    disableAfterReachingLimit: false,
    bvmMC: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ActivityCheckBreathing.prototype.initialize.apply(this, arguments);
    },

    onBeforeDestroy: function()
    {
      ActivityCheckBreathing.prototype.onBeforeDestroy.apply(this);

      this.doneBtn.off('click');
      this.doneBtn.addClass('disabled');
    },

    setupRescueBreaths: function()
    {
      this.bvmMC = this.currentScene.find('[data-mc=bvm_mc]');
      // setup the body and bvm states TODO

      this.playAudio('audio', this.currentPhase);
      this.currentPhase.hideCounter = (this.currentPhase.hideCounter !== undefined && (this.currentPhase.hideCounter === true || this.currentPhase.hideCounter.toLowerCase() === 'true'));
      this.currentPhase.hidePace = (this.currentPhase.hidePace !== undefined && (this.currentPhase.hidePace === true || this.currentPhase.hidePace.toLowerCase() === 'true'));

      this.counterPanel = this.currentScene.find('[data-mc=counterHolder]');
      this.showTime();

      if (this.counterPanel.length > 0)
      {
        this.counterPanel.find('[data-mc=text_tf]').show();
        this.counterPanel.find('[data-mc=disabled_mc]').hide();
        this.counterPanel.find('[data-mc=message]').show();
        if (this.currentPhase.hideCounter === true)
        {
          //console.log('hide counter', this.currentPhase.hideCounter, typeof(this.currentPhase.hideCounter), this.currentPhase);
          this.counterPanel.find('[data-mc=text_tf]').hide();
          this.counterPanel.find('[data-mc=disabled_mc]').show();
        }
        if (this.currentPhase.hidePace)
          this.counterPanel.find('[data-mc=message]').hide();

        if (this.currentPhase.hideCounter && this.currentPhase.hidePace)
        {
          this.counterPanel.hide();//visible = false;
        }
      }

      this.attempt = 0;
      this.minHoldCount = 1;
      this.maxHoldCount = 4;

      if (!Scenario.getVariableByName('goodBreaths') && !Scenario.getVariableByName('badBreaths'))
      {
        this.minPressCount = 2;
        this.disableAfterReachingLimit = true;
      }

      var $mouth = this.currentScene.find('[data-mc=mouth]');
      this.breathingButton = $mouth;//new Button($mouth);
      this.breathingButton.on('touchstart mousedown', $.proxy(this.onMouseDownHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );

      this.setHeadTilt();

      this.doneBtn = this.get('[data-mc=doneHolder] [data-mc=done]');
      this.doneBtn.addClass('disabled');
    },

    startTimer: function($delay)
    {
      $delay = ($delay === undefined) ? 500 : $delay;

      this.isTimeExceeded = false;

      if (!this.timer)
      {
        this.timer = new ActivityTimer($delay);
        this.timer.on(ActivityTimer.TIMER, $.proxy(this.timerTickHandler, this));
      }

      this.timer.reset();
      this.timer.start();
    },

    startAction: function()
    {
      ActivityCheckBreathing.prototype.startAction.apply(this, arguments);
      this.currentScene.addClass('attempt-breath');
      if (this.airwayOpen)
      {
        var $bodyEl = this.currentScene.find('[data-mc=body] .chest-rise');
        //var $scale = 1;
        var $scaleDelta = 0.001;
        if ($bodyEl.attr('data-delta'))
          $scaleDelta = Number($bodyEl.attr('data-delta'));

        //console.log('start breath', $bodyEl);
        /*$bodyEl.stop().animate({obj: 100}, {duration: 2000, step: function() {
          $scale += $scaleDelta;
          $bodyEl.css('transform', 'scaleY(' + $scale + ')');
          ////console.log('step', arguments);
        }});*/
        TweenLite.fromTo($bodyEl, 2, {scaleY: 1}, {scaleY: 1.125});
      }

      if (this.channel)
        this.channel.once('channel.playing', $.proxy(this.audioStarted, this));
      // TODO add breathing and bvm animations
    },

    stopAction: function()
    {
      var d = new Date();
      var t = d.getTime();

      if (this.channel)
        this.channel.off('channel.playing');

      this.stopMedia();
      this.totalBreathsCount++;

      //var $bodyEl = this.currentScene.find('[data-mc=body] .chest-rise').stop().css('transform', 'scaleY(1)');
      this.currentScene.removeClass('attempt-breath');
      // this.currentScene.find('[data-mc=body] .chest-rise').stop().css('transform', 'scaleY(1)');
      var $bodyEl = this.currentScene.find('[data-mc=body] .chest-rise');
      TweenLite.killTweensOf($bodyEl);
      $bodyEl.css('transform', 'scaleY(1)');
      //$bodyEl.stop().animate({transform: 'scale(1,1)'}, {duration: 500});

      this.breathingButton.on('touchstart mousedown', $.proxy(this.onMouseDownHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.breathingButton.off('touchend mouseup');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.breathingButton.off('mouseout');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );

      this.counterPanel.find('[data-mc=text_tf]').html(this.totalBreathsCount);

      var $breathVar = (this.airwayOpen) ? Scenario.getVariableByName('goodBreaths') : Scenario.getVariableByName('badBreaths');
      var $newVal;

      if ($breathVar)
      {
        $newVal = (!isNaN($breathVar.currentValue)) ? ($breathVar.currentValue + 1) : 1;
        $breathVar.setValue($newVal);
      }

      this.stopTimer();
      this.currentScene.find('[data-mc=body]');//.gotoAndStop(1);
      if (this.bvmMC)
      {
        //this.bvmMC;//.gotoAndStop(1);
      }
      //this.mc.body.removeEventListener(Event.ENTER_FRAME, this.onEnterFrame);
      ////console.log('check timer', this.timer.currentCount, this.minHoldCount, this.maxHoldCount);

      if (!this.timer)
        return;

      var $startDuration = t - this.startTime;
      var $audioDuration = t - this.audioTime;

      var $inRange = ($startDuration > 500 && $startDuration < 1750) || ($audioDuration > 500 && $audioDuration < 1750);

      this.startTime = 0;
      this.audioTime = 0;

      //if ((this.timer.currentCount < this.minHoldCount || this.timer.currentCount > this.maxHoldCount))
      if (!$inRange)
      {
        //console.log('downgrade');
        this.downgradePerformance();

        if (this.totalBreathsCount >= 2) // play final incorrect
        {
          this.playAudio('audio-feedback-incorrect-final', this.currentPhase);
        }
        else if (this.timer.currentCount < this.minHoldCount)
        {

          this.playAudio('audio-feedback-incorrect-low', this.currentPhase);
        }
        else
        {
          this.playAudio('audio-feedback-incorrect-high', this.currentPhase);
        }
      }
      else
      {
        this.playAudio('audio-feedback-correct', this.currentPhase);
      }

      if ((!this.disableAfterReachingLimit || this.totalBreathsCount >= 2) && this.doneBtn.hasClass('disabled'))
      {
        this.doneBtn.removeClass('disabled');
        this.doneBtn.one('click', $.proxy(this.onDoneClick, this));
        if (this.disableAfterReachingLimit)
          this.disableBreathButton();
      }
    },

    timerTickHandler: function(e)
    {
      // empty to prevent super
    },

    onDoneClick: function()
    {
      this.doneBtn.addClass('disabled');
      this.doneBtn.off('click');
      this.evaluatePerformance();
    },

    evaluatePerformance: function()
    {
      this.finish();
    },

    showTime: function($sec)
    {
      $sec = ($sec === undefined) ? 0 : $sec;
      if (!this.counterPanel)
        return;

      this.counterPanel.find('[data-mc=text_tf]').html($sec.toString());
    }

  /*****************************************************************************************************************///}

  });

  return ActivityRescueBreaths;

});

